<template>
  <v-flex xs12 sm12 d-block class="card-dados card-dados__mobile">
    <div class="card-dados__titulo resultado-card mb-0">
      <h3 id="tituloPainel">Resultado</h3>

      <div class="resultado-card">
        <v-tooltip
            v-if="deveExibirBotaoIncluirPropostaManual"
            top
            :disabled="!desabilitarIncluirPropostaManual()">
          <template v-slot:activator="{ on }">
            <v-btn
                v-az-auth="'Comprador.Admin,Comprador.Normal,Comprador.Autoridade.Superior'"
                class="botao-incluir-proposta-manual"
                color="primary"
                small
                flat
                outline
                :disabled="desabilitarIncluirPropostaManual()"
                v-on="on"
                @click="incluirPropostaManual">
              <v-icon left small>fas fa-plus-circle</v-icon>
              Incluir Proposta Manualmente
            </v-btn>
          </template>
          Incluir Proposta Manualmente
        </v-tooltip>
        <botao-central-mensagens-chat v-if="!ehCompraPropostaManualEhAtiva"
                                      :total-nao-lidas="totalMensagensNaoLidaCentral"
                                      @abrirChatNoTabItensLotes="$emit('abrirChatNoTabItensLotes')"/>
        <v-tooltip
            :disabled="!desabilitarEncerrar()"
            top>
          <a slot="activator">
            <v-btn v-az-auth="'Comprador.Admin,Comprador.Normal,Comprador.Autoridade.Superior'"
                   class="botao-encerrar"
                   color="primary"
                   small
                   depressed
                   :disabled="desabilitarEncerrar()"
                   @click="dialogEncerrar = true">
              Encerrar compra
            </v-btn>
          </a>
          <span v-if="situacaoCompraDireta === 'ENCERRADA'">
                        A compra já está encerrada.
                    </span>
          <span v-else>
                        Para encerrar a compra é necessário que todos os itens tenham a situação diferente de "Em Andamento".
                    </span>
        </v-tooltip>

        <mensagem-confirmacao :exibirMensagem="dialogEncerrar"
                              titulo="Encerrar compra"
                              textoSecundario="Deseja realmente encerrar a compra?"
                              @confirmado="encerrarCompra()"
                              @recusado="dialogEncerrar = false"/>

        <acoes-documentos-compra-direta
            v-show="deveMostrarBotoesVirtualizacao"
            class="documentos-compra-direta"
            @acessarDocumentosCompraDireta="tratarEventoAcessarDocumentos" />

        <acoes-processo-digital v-show="deveMostrarProcessoDigital" :processoVirtualUrl="resumoCompraDireta.processoVirtualUrl"/>

        <acoes-processo-edocs
            v-if="deveMostrarEdocsVirtualizacao"
            :mostrar-alerta="false"
            :processoVirtualUrl="resumoCompraDireta.processoVirtualUrl"
            :processoVirtual="resumoCompraDireta.processoVirtual"
            status="this.statusEdocs"
            texto-alerta="this.textoAlertaEdocs"
        />

        <acoes-relatorios :ehCompraFluxoAutoridadeSuperior="ehCompraFluxoAutoridadeSuperior"
                          :ehCompraPropostaManualEhAtiva="ehCompraPropostaManualEhAtiva"
                          @baixarAta="$emit('baixarAta')"
                          @baixarHistoricoLances="$emit('baixarHistoricoLances')"
                          @baixarResultado="$emit('baixarResultado')"
                          @baixarTermoHomologacao="$emit('baixarTermoHomologacao')"/>
      </div>
    </div>

    <div v-if="value.length > 1" class="acao-expandir-recolher">
      <botao-homologar-adjudicar-item-lote
          v-if="ehProcessoDeHomologacaoAutoridadeSuperior && !ehCompraSuspensa()"
          @homologarAdjudicarItemLote="$emit('homologarAdjudicarItemLote')"/>
      <v-spacer></v-spacer>
      <div class="text-xs-right">
        <v-btn v-if="ultimoEstadoPaineis === 'recolhido'" flat @click="expandirTodos" class="botao-simples mr-3">
          <v-icon left size="15">fas fa-chevron-down</v-icon>
          Expandir Todos
        </v-btn>

        <v-btn v-else flat @click="recolherTodos" class="botao-simples mr-3">
          <v-icon left size="15">fas fa-chevron-up</v-icon>
          Recolher Todos
        </v-btn>
      </div>
    </div>
    <v-expansion-panel v-model="paineis"
                       expand
                       class="painel-itens"
                       :class="{ 'mt-3': value.length < 2}">
      <v-expansion-panel-content v-for="itemOuLote in value"
                                 :key="`${itemOuLote.id}-${itemOuLote.tipo}-expansion-panel-content`"
                                 class="painel-itens__linha borda-linha cabecalho-painel">
        <template v-slot:header>
          <div class="alinhar-info">
            <strong>{{ itemOuLote.descricao }}</strong>

            <p class="ml-2 mb-0">
              <small v-if="semValorReferencia">(Sem valor estimado)</small>
              <small v-else>(Valor Ref. {{ itemOuLote.valorReferencia | cdCurrency(prefix, casasDecimais) }}{{suffix}})</small>
              -
              <v-tooltip top v-if="itemOuLote.motivo">
                <a slot="activator">
                  {{ itemOuLote.situacao | azEnum(situacoesItensELotes)}}
                  <i class="fas fa-comment" aria-hidden="true"/>
                </a>
                {{ itemOuLote.motivo }}
              </v-tooltip>
              <span v-else>
                                {{ itemOuLote.situacao | azEnum(situacoesItensELotes)}}
                            </span>
              <v-tooltip top v-if="exibirBotaoReverter(itemOuLote)"
                         @click.native.stop="abrirDialogoConfirmarReverter(itemOuLote)">
                <a slot="activator">
                  <i class="fas fa-undo pl-3" aria-hidden="true" style="font-size: 1em;"/>
                </a>
                Reverter
              </v-tooltip>
            </p>

            <az-call-to-action v-az-auth="'Comprador.Admin,Comprador.Normal,Comprador.Autoridade.Superior'"
                               v-if="exibirDesempatar(itemOuLote)"
                               :key="`${itemOuLote.tipo}-${itemOuLote.id}-botao-desempatar`"
                               @click.native.stop="iniciarEnvioParaDesempate(itemOuLote)"
                               active class="text-uppercase botaoDesempatar">
              Desempatar
            </az-call-to-action>
            <az-call-to-action v-else-if="exibirDesempatarManual(itemOuLote)"
                               :key="`${itemOuLote.tipo}-${itemOuLote.id}-botao-manual`"
                               v-az-auth="'Comprador.Admin,Comprador.Normal,Comprador.Autoridade.Superior'"
                               @click.native.stop="$emit('eventoIniciarDesempateManual', itemOuLote)"
                               active class="text-uppercase botaoDesempatar">
              Resolver Desempate
            </az-call-to-action>

            <span class="ml-3" v-if="deveExibirCountDown(itemOuLote)">
                            <count-down-desempate :key="`${itemOuLote.tipo}-${itemOuLote.id}-count-down`"
                                                  :data-hora-atual="itemOuLote.dataHoraAtual"
                                                  :data-hora-fim-desempate="itemOuLote.dataHoraFimDesempate"
                                                  @tempoDesempateEncerrado="$emit('tempoDesempateEncerrado')"/>
                            | Desempate Em Andamento
                        </span>

            <v-spacer></v-spacer>
            <botao-visualizar-propostas v-if="deveMostraBotaoVisualizarProposta(itemOuLote) && !ehCompraPropostaManualEhAtiva" texto="Visualizar Propostas" class="mr-4"
                                        :deshabilitado="false"
                                        color-class="primary-color"
                                        mensagem-tooltip="Clique para baixar todas as propostas do item/lote"
                                        @eventoVisualizarPropostas="eventoVisualizarProposta(itemOuLote)"/>
          </div>
        </template>

        <painel-ranking-tabela v-model="itemOuLote.ranking" :key="`painel-ranking-${itemOuLote.id}`"
                               :situacaoItemOuLote="itemOuLote.situacao"
                               :itemOuLoteDescricao="itemOuLote.descricao"
                               :lanceFechadoFinalizado="itemOuLote.lanceFechadoFinalizado"
                               :situacaoCompraDireta="situacaoCompraDireta"
                               :casasDecimais="casasDecimais"
                               :itemOuLoteId="itemOuLote.id"
                               :adjudicarRequerConfirmacao="itemOuLote.adjudicarRequerConfirmacao"
                               :criterioJulgamento="criterioJulgamento"
                               :simboloCriterioJulgamento="simboloCriterioJulgamento"
                               :prefixSuffixValor="prefixSuffixValor"
                               :validarLancesPor="validarIntervaloLancesPor"
                               :compraDiretaId="idCompraAtivo"
                               :estaEmHomologacao="itemLoteEstaEmHomologacao(itemOuLote)"
                               @baixarTodosDocumentos = "baixarTodosDocumentos"
                               @eventoAbrirModalSolicitarReadequacao="eventoAbrirModalSolicitarReadequacao(itemOuLote, ...arguments)"
                               @adjudicar="propagarEventoAdjudicar(itemOuLote.tipo, ...arguments)"
                               @declararVencedor="propagarEventoDeclararVencedor(itemOuLote.tipo, ...arguments)"
                               @enviarParaHomologacao="propagarEventoEnviarParaHomologacao(itemOuLote.tipo, ...arguments)"
                               @desclassificar="propagarEventoDesclassificar(itemOuLote.tipo, ...arguments)"
                               @inabilitar="propagarEventoInabilitar(itemOuLote.tipo, ...arguments)"
                               @reclassificar="propagarEventoReclassificar(itemOuLote.tipo, ...arguments)"
                               @habilitar="propagarEventoHabilitar(itemOuLote.tipo, ...arguments)"
                               @negociar="propagarEventoNegociar(itemOuLote, ...arguments)"
                               @analisarDocumentacao="propagarEventoAnalisar(itemOuLote.tipo, ...arguments)"
                               @cancelarAdjudicacao="(dadosRanking) => propagarEventoCancelarAdjudicacao(itemOuLote, dadosRanking)"
                               @cancelarDeclaracaoVencedor="propagarEventoCancelarDeclaracaoVencedor(itemOuLote, ...arguments)"
                               @cancelarNegociacao="propagarEventoCancelarNegociacao(itemOuLote, ...arguments)"
                               @abrirChatMensages="propagarEventAbrirChatMensagens(itemOuLote, ...arguments)"
                               @cancelarEnvioHomologacao="propagarEventoCancelarEnvioHomologacao(itemOuLote.tipo, ...arguments)"
                               @eventoMostrarMotivoDevolucao="(ranking) => mostrarMotivoDevolucaoItemLote(itemOuLote, ranking)"
                               @abrirModalParaDevolucao="(ranking) => $emit('propagarEventoAbrirModalMotivoDevolucao', itemOuLote, ranking)"
                               @removerProposta="propagarEventoRemoverProposta(itemOuLote, ...arguments)"/>

      </v-expansion-panel-content>
    </v-expansion-panel>

    <botao-homologar-adjudicar-item-lote
        v-if="ehProcessoDeHomologacaoAutoridadeSuperior && !ehCompraSuspensa()"
        @homologarAdjudicarItemLote="$emit('homologarAdjudicarItemLote')"/>

    <mensagem-confirmacao :exibirMensagem="mostrarDialogoReverter"
                          titulo="Reverter situação"
                          :textoSecundario="textoMensagemReverter()"
                          @confirmado="emitirEventoReverterSituacao()"
                          @recusado="() => {this.itemLoteReverter = null; this.mostrarDialogoReverter = false}"/>

    <modal-solicitar-readequacao :visibilidadeDialogoSolicitarReadequacao="visibilidadeDialogoSolicitarReadequacao"
                                 v-if="!ehCompraSuspensa()"
                                 v-model="itemOuLoteReadequacao"
                                 :suffix="suffix"
                                 :prefix="prefix"
                                 :casasDecimais="casasDecimais"
                                 @solicitarReadequacao="propagarEventoSolicitarReadequacao"
                                 @fecharModalSolicitarReadequacao="fecharModalSolicitarReadequacao"/>

    <modal-mostar-mensagem :deve-mostar-mensagem="deveMostarMotivoDevolucao"
                           com-botao-cancelar
                           tamanho-maximo="500"
                           :titulo="`${elementoDevolvido.descricao} | Motivo de devolução`"
                           :texto-secundario="elementoDevolvido.motivoDevolucao"
                           @cancelar="deveMostarMotivoDevolucao = false; elementoDevolvido = {}"/>

    <modal-desempate-etapa-fechada :exibirModal="mostrarModalDesempateEtapaFechada"
                                   v-if="!ehCompraSuspensa()"
                                   @fecharModal="fecharModalInicioDesempate"
                                   @desempatar="confirmarEnvioParaDesempate"/>
  </v-flex>
</template>

<script>
import {mapState} from 'vuex'
import {situacoesItensELotes, situacoesHomologacao, actionTypes} from '@/core/constants'
import PainelRankingTabela from '@/views/pages/comprador/execucao-compra-direta/resultado/painel-ranking/PainelRankingTabela.vue'
import AcoesRelatorios from '@/views/pages/comprador/execucao-compra-direta/resultado/painel-ranking/acoes/AcoesRelatorios'
import AcoesProcessoDigital from '@/views/pages/comprador/execucao-compra-direta/resultado/painel-ranking/acoes/AcoesProcessoDigital'
import AcoesDocumentosCompraDireta from '@/views/pages/comprador/execucao-compra-direta/resultado/painel-ranking/acoes/AcoesDocumentosCompraDireta'
import BotaoVisualizarPropostas from '@/views/pages/comprador/execucao-compra-direta/resultado/painel-ranking/BotaoVisualizarPropostas'
import ModalSolicitarReadequacao from '@/views/pages/comprador/execucao-compra-direta/resultado/painel-ranking/acoes/ModalSolicitarReadequacao.vue'
import BotaoCentralMensagensChat from '@/views/pages/commons/chat-compra-direta/components/BotaoCentralMensagensChat'
import MensagemConfirmacao from '@/views/components/MensagemConfirmacao.vue'
import ModalMostarMensagem from '@/views/components/ModalMostrarMensagem.vue'
import BotaoHomologarAdjudicarItemLote from '../../acoes/BotaoHomologarAdjudicarItemLote'
import ModalDesempateEtapaFechada from '@/views/pages/comprador/execucao-compra-direta/resultado/components/ModalDesempateEtapaFechada.vue'
import azAuth from '@azinformatica/loki/src/utils/az-auth'
import CountDownDesempate from '@/views/components/CountDownDesempate'
import AcoesProcessoEdocs
from '@/views/pages/comprador/execucao-compra-direta/resultado/painel-ranking/acoes/AcoesProcessoEdocs.vue'

export default {
    name: 'PainelRanking',
    props: {
        value: {
            required: true,
            type: Array,
            default: () => {
                return []
            }
        },
        situacaoCompraDireta: {
            type: String,
            required: true
        },
        semValorReferencia: {
            type: Boolean,
            default: false
        },
        existeItemLoteComSituacaoEmAndamento: {
            type: Boolean,
            default: false
        },
        casasDecimais: {
            type: Number,
            default: 2
        },
        compraDiretaId: {
            type: Number,
            default: null
        },
        numeroProtocolo: {
            type: String
        },
        totalElements: {
            type: Number,
            default: 0
        },
        totalPages: {
            type: Number,
            default: 0
        }
    },
    components: {
        AcoesProcessoEdocs,
        CountDownDesempate,
        BotaoHomologarAdjudicarItemLote,
        ModalMostarMensagem,
        MensagemConfirmacao,
        BotaoCentralMensagensChat,
        ModalSolicitarReadequacao,
        AcoesRelatorios,
        PainelRankingTabela,
        AcoesProcessoDigital,
        AcoesDocumentosCompraDireta,
        BotaoVisualizarPropostas,
        ModalDesempateEtapaFechada
    },
    mounted() {
        this.expandirTodos()
    },
    data() {
        return {
            situacoesItensELotes,
            paineis: [],
            ultimoEstadoPaineis: 'recolhido',
            totalmenteRecolhido: true,
            totalmenteExpandido: false,
            dialogEncerrar: false,
            mostrarDialogoReverter: false,
            itemLoteReverter: null,
            visibilidadeDialogoSolicitarReadequacao: false,
            itemOuLoteReadequacao: {},
            deveMostarMotivoDevolucao: false,
            elementoDevolvido: {},
            mostrarModalDesempateEtapaFechada: false,
            itemLoteDesempate: null,
            textoAlertaEdocs: '',
            statusEdocs: '',
        }
    },
    computed: {
        ...mapState(['loki', 'resumoCompraDireta', 'chat', 'parametros']),
        deveMostrarBotoesVirtualizacao(){
            return this.resumoCompraDireta.virtualizada
        },
        deveMostrarEdocsVirtualizacao(){
            return this.resumoCompraDireta.virtualizada &&
          this.parametros.propriedadesCompraDiretas.identidadeCliente === 'ES' &&
          this.parametros.propriedadesCompraDiretas.integration.edocs.ativo === true
        },
        deveMostrarProcessoDigital(){
            return this.resumoCompraDireta.virtualizada &&
          this.parametros.propriedadesCompraDiretas.integration.edocs.ativo === false
        },
        criterioJulgamento(){
            return this.resumoCompraDireta.criterioJulgamento
        },
        simboloCriterioJulgamento(){
            return this.resumoCompraDireta.simboloCriterioJulgamento
        },
        prefixSuffixValor(){
            return this.resumoCompraDireta.prefixoValor
        },
        validarIntervaloLancesPor(){
            return this.resumoCompraDireta.intervaloLancesPor
        },
        prefix(){
            return this.resumoCompraDireta.prefixoValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.resumoCompraDireta.prefixoValor === '%' ? '%' : ''
        },
        totalMensagensNaoLidaCentral(){
            return this.chat.centralMensagens.totalNaoLidas
        },
        ehProcessoDeHomologacaoAutoridadeSuperior() {
            return ((this.$route.query.processamento && this.$route.query.processamento === 'homologacao')
          && azAuth(this.$store.state.loki.user.authorities, ['Comprador.Autoridade.Superior'])
          && this.existeAlgumItemLoteEmHomologacao)
        },
        existeAlgumItemLoteEmHomologacao() {
            return this.value.some(item => item.estaEmHomologacao)
        },
        ehCompraFluxoAutoridadeSuperior(){
            return this.resumoCompraDireta.ehFluxoAutoridadeSuperior
        },
        ehCompraPropostaManualEhAtiva() {
            return this.propostaManualAtiva && this.amparoLegalEhLei14133Art75VIII
        },
        propostaManualAtiva() {
            return Boolean(this.parametros.propriedadesCompraDiretas.propostaManual)
        },
        amparoLegalEhLei14133Art75VIII() {
            const lei = this.resumoCompraDireta?.amparoLegal?.lei || ''
            return typeof lei === 'string' && lei.includes('Lei 14.133/2021, Art. 75, VIII')
        },
        deveExibirBotaoIncluirPropostaManual() {
            return this.ehCompraPropostaManualEhAtiva
        },
        idCompraAtivo() {
            const fromProp = (this.compraDiretaId !== null && this.compraDiretaId !== undefined) ? Number(this.compraDiretaId) : null
            const fromResumo = this.resumoCompraDireta?.id ? Number(this.resumoCompraDireta.id) : null

            const choose = fromProp ?? fromResumo
            return Number.isFinite(choose) ? choose : null
        }
    },
    methods: {
        abrirDialogoConfirmarReverter(itemOuLote){
            this.itemLoteReverter = itemOuLote
            this.mostrarDialogoReverter = true
        },
        expandirTodos() {
            const todosPaineisAbertos = this.value.map(() => {
                return true
            })
            this.paineis = todosPaineisAbertos
            this.totalmenteExpandido = true
            this.verificarUltimoEstado()
        },
        verificarUltimoEstado() {
            if (this.totalmenteExpandido) {
                this.ultimoEstadoPaineis = 'expandido'
            } else if (this.totalmenteRecolhido) {
                this.ultimoEstadoPaineis = 'recolhido'
            }
        },
        recolherTodos() {
            const todosPaineisFechados = this.value.map(() => {
                return false
            })
            this.paineis = todosPaineisFechados
            this.totalmenteExpandido = false
        },
        iniciarEnvioParaDesempate(itemOuLote) {
            this.mostrarModalDesempateEtapaFechada = true
            this.itemLoteDesempate = itemOuLote
        },
        confirmarEnvioParaDesempate() {
            this.$emit('desempatar', { ...this.itemLoteDesempate })
            this.fecharModalInicioDesempate()
        },
        fecharModalInicioDesempate(){
            this.mostrarModalDesempateEtapaFechada = false
            this.itemLoteDesempate = {}
        },
        emitirEventoReverterSituacao() {
            const comboReverterSituacao = {
                itemOuLoteId: this.itemLoteReverter.id,
                tipoItemOuLote: this.itemLoteReverter.tipo
            }
            this.itemLoteReverter = null
            this.mostrarDialogoReverter = false
            this.$emit('reverterSituacao', comboReverterSituacao)
        },
        propagarEventoDeclararVencedor(tipoItemOuLote, rankingId, pessoaId, itemOuLoteId, situacaoItemOuLote) {
            let comboPainelRanking = {
                tipoItemOuLote: tipoItemOuLote,
                rankingId: rankingId,
                pessoaId: pessoaId,
                itemOuLoteId: itemOuLoteId,
                situacaoItemOuLote: situacaoItemOuLote,
            }
            this.$emit('declararVencedor', comboPainelRanking)
        },
        propagarEventoEnviarParaHomologacao(tipoItemOuLote, rankingId) {
            let comboPainelRanking = {
                tipoItemOuLote: tipoItemOuLote,
                rankingId: rankingId
            }
            this.$emit('enviarParaHomologacao', comboPainelRanking)
        },
        propagarEventoAdjudicar(tipoItemOuLote, rankingId) {
            let comboPainelRanking = {
                tipoItemOuLote: tipoItemOuLote,
                rankingId: rankingId
            }
            this.$emit('adjudicar', comboPainelRanking)
        },
        propagarEventoAnalisar(tipo, comboPainelRankingTabela) {
            let itemLoteId = null
            if(tipo === 'ITEM')
                itemLoteId = comboPainelRankingTabela.itemId
            if(tipo === 'LOTE')
                itemLoteId = comboPainelRankingTabela.loteId

            const combo = {
                pessoaId: comboPainelRankingTabela.pessoaId,
                itemLoteId: itemLoteId,
                itemLoteTipo: tipo
            }
            this.$emit('analisarDocumentacao', combo)
        },
        propagarEventoDesclassificar(tipoItemOuLote, comboPainelRankingTabela) {
            let comboPainelRanking = {
                tipoItemOuLote: tipoItemOuLote,
                rankingId: comboPainelRankingTabela.rankingId,
                motivo: comboPainelRankingTabela.motivo
            }
            this.$emit('desclassificar', comboPainelRanking)
        },
        propagarEventoInabilitar(tipoItemOuLote, comboPainelRankingTabela) {
            let comboPainelRanking = {
                tipoItemOuLote: tipoItemOuLote,
                rankingId: comboPainelRankingTabela.rankingId,
                fornecedorId: comboPainelRankingTabela.pessoaId,
                motivo: comboPainelRankingTabela.motivo,
                inabilitarTodos: comboPainelRankingTabela.inabilitarTodos
            }

            this.$emit('inabilitar', comboPainelRanking)
        },
        propagarEventoHabilitar(tipoItemOuLote, comboPainelRankingTabela) {
            let comboPainelRanking = {
                tipoItemOuLote: tipoItemOuLote,
                rankingId: comboPainelRankingTabela.rankingId,
                fornecedorId: comboPainelRankingTabela.pessoaId,
                motivo: comboPainelRankingTabela.motivo,
                habilitarTodos: comboPainelRankingTabela.habilitarTodos
            }

            this.$emit('habilitar', comboPainelRanking)
        },
        propagarEventoReclassificar(tipoItemOuLote, comboPainelRankingTabela) {
            const comboPainelRanking = {
                tipoItemOuLote: tipoItemOuLote,
                rankingId: comboPainelRankingTabela.rankingId,
                motivo: comboPainelRankingTabela.motivo
            }
            this.$emit('reclassificar', comboPainelRanking)
        },
        propagarEventoNegociar(itemOuLote, comboPainelRankingTabela) {
            let comboPainelRanking = {
                tipoItemOuLote: itemOuLote.tipo,
                itemOuLoteId: itemOuLote.id,
                rankingId: comboPainelRankingTabela.rankingId,
                mensagem: comboPainelRankingTabela.mensagem
            }
            this.$emit('negociar', comboPainelRanking)
        },
        propagarEventoCancelarAdjudicacao(itemOuLote, comboPainelRankingTabela){
            let comboPainelRanking = {
                tipoItemOuLote: itemOuLote.tipo,
                itemOuLoteId: itemOuLote.id,
                rankingId: comboPainelRankingTabela.rankingId,
                motivo: comboPainelRankingTabela.motivo,
                pessoaId: comboPainelRankingTabela.pessoaId
            }
            this.$emit('cancelarAdjudicacao', comboPainelRanking)
        },
        propagarEventoCancelarDeclaracaoVencedor(itemOuLote, comboPainelRankingTabela){
            let comboPainelRanking = {
                tipoItemOuLote: itemOuLote.tipo,
                itemOuLoteId: itemOuLote.id,
                rankingId: comboPainelRankingTabela.rankingId,
                motivo: comboPainelRankingTabela.motivo,
                pessoaId: comboPainelRankingTabela.pessoaId
            }
            this.$emit('cancelarDeclaracaoVencedor', comboPainelRanking)
        },
        propagarEventoCancelarNegociacao(itemOuLote, comboPainelRankingTabela) {
            let comboPainelRanking = {
                compraDiretaId: this.idCompraAtivo,
                tipoItemOuLote: itemOuLote.tipo,
                itemOuLoteId: itemOuLote.id,
                negociacaoId: comboPainelRankingTabela.itemOuLote.negociacao.id,
                motivo: comboPainelRankingTabela.motivo
            }
            this.$emit('cancelarNegociacao', comboPainelRanking)
        },
        exibirDesempatar(itemOuLote){
            return (itemOuLote.empate && !itemOuLote.estaEmDesempate && !itemOuLote.lanceFechadoFinalizado &&
          this.compraEmAnaliseOuReanalise() && (itemOuLote.situacao === 'EM_ANDAMENTO') && !(this.propostaManualAtiva && this.amparoLegalEhLei14133Art75VIII))
        },
        exibirDesempatarManual(itemOuLote) {
            return (itemOuLote.empate && !itemOuLote.estaEmDesempate && (itemOuLote.lanceFechadoFinalizado || (this.propostaManualAtiva && this.amparoLegalEhLei14133Art75VIII))
          && this.compraEmAnaliseOuReanalise() && (itemOuLote.situacao === 'EM_ANDAMENTO'))
        },
        deveExibirCountDown(itemOuLote) {
            return (itemOuLote.empate && itemOuLote.estaEmDesempate && !itemOuLote.lanceFechadoFinalizado
          && this.compraEmAnaliseOuReanalise() && (itemOuLote.situacao === 'EM_ANDAMENTO'))
        },
        compraEmAnaliseOuReanalise(){
            return ['EM_ANALISE', 'REANALISE'].includes(this.situacaoCompraDireta)
        },
        tratarEventoAcessarDocumentos() {
            const id = this.idCompraAtivo
            this.$router.push({name: 'documentosCompraDireta', params: {id}})
        },
        encerrarCompra() {
            this.$emit('encerrarCompra')
            this.dialogEncerrar = false
        },
        baixarTodosDocumentos(data) {
            this.$emit('baixarTodosDocumentos', data)
        },
        ehCompraEncerrada() {
            return this.situacoesCompraDireta[this.situacaoCompraDireta] === this.situacoesCompraDireta.ENCERRADA
        },
        ehCompraSuspensa() {
            return this.situacaoCompraDireta === 'SUSPENSA'
        },
        existeItemLoteComSituacaoEmElaboracao() {
            return !this.value.every((itemLote) => {
                return this.situacoesItensELotes[itemLote.situacao] !== this.situacoesItensELotes.EM_ELABORACAO
            })
        },
        desabilitarEncerrar() {
            return this.ehCompraEncerrada() || this.existeItemLoteComSituacaoEmAndamento || this.ehCompraSuspensa()
        },
        desabilitarIncluirPropostaManual() {
            return this.ehCompraSuspensa() || !this.idCompraAtivo || this.ehCompraEncerrada()
                || !(this.existeItemLoteComSituacaoEmAndamento || this.existeItemLoteComSituacaoEmElaboracao())
        },
        textoMensagemReverter(){
            const mensagemBase = 'Deseja realmente reverter a situação'
            const itemLote = this.itemLoteReverter
            if(itemLote){
                return `${mensagemBase} "${itemLote.situacao}" para o ${itemLote.descricao}`
            }
            return ''
        },
        exibirBotaoReverter(itemOuLote){
            return itemOuLote.isSituacaoRejeicao && itemOuLote.situacao !== 'DESERTO' && itemOuLote.ranking.length > 0 && !this.ehCompraSuspensa()
        },
        deveMostraBotaoVisualizarProposta(itemOuLote){
            return itemOuLote.situacao !== 'DESERTO'
        },
        eventoVisualizarProposta(itemOuLote){
            this.$emit('eventoVisualizarProposta', {id: itemOuLote.id, tipo: itemOuLote.tipo})
        },
        eventoAbrirModalSolicitarReadequacao(itemOuLote, ranking) {
            this.itemOuLoteReadequacao = {
                itemOuLoteId: itemOuLote.id,
                tipo: itemOuLote.tipo,
                descricao: itemOuLote.descricao,
                pessoa: ranking.pessoaId,
                lanceVencedor: ranking.lanceVencedor,
                razaoSocial: ranking.razaoSocial,
                observacao: null
            }
            this.visibilidadeDialogoSolicitarReadequacao = true
        },
        fecharModalSolicitarReadequacao(){
            this.visibilidadeDialogoSolicitarReadequacao = false
            this.itemOuLoteReadequacao = {}
        },
        propagarEventoSolicitarReadequacao() {
            this.$emit('enviarSolicitacaoReadequacaoItemLote', {...this.itemOuLoteReadequacao})
            this.fecharModalSolicitarReadequacao()
        },
        propagarEventAbrirChatMensagens(itemOuLote, resultadoItemLote){
            this.$emit('abrirChatMensages', itemOuLote, resultadoItemLote)
        },
        propagarEventoCancelarEnvioHomologacao(tipoItemOuLote, rankingId) {
            let comboPainelRanking = {
                tipoItemOuLote: tipoItemOuLote,
                rankingId: rankingId
            }
            this.$emit('cancelarEnvioHomologacao', comboPainelRanking)
        },
        propagarEventoRemoverProposta(itemOuLote, comboRemoverProposta) {
            this.$emit('removerProposta', comboRemoverProposta)
        },
        mostrarMotivoDevolucaoItemLote({descricao}, {motivoDevolucao}) {
            this.elementoDevolvido = {descricao, motivoDevolucao}
            this.deveMostarMotivoDevolucao = true
        },
        itemLoteEstaEmHomologacao(elemento) {
            const { ...situacoesLegais } = situacoesHomologacao
            return elemento.estaEmHomologacao || elemento.ranking.some(rank => Object.keys(situacoesLegais).includes(rank.processamento))
        },
        deveMostrarAlertaEdocs() {
            if(this.resumoCompraDireta.situacaoEdocs === 'EM_PROCESSAMENTO') {
                this.statusEdocs = 'warning'
                this.textoAlertaEdocs = 'Documentos em processamento no E-Docs'
                return true
            }

            return false
        },
        async buscarSituacaoEdocs() {
            const propsCompra = this.parametros?.propriedadesCompraDiretas
            if (!(propsCompra?.identidadeCliente === 'ES' && propsCompra?.integration?.edocs?.ativo)) {
                return
            }

            const compraId = this.idCompraAtivo
            if (typeof compraId !== 'number' || !Number.isFinite(compraId)) {
                return
            }

            try {
                await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_SITUACAO_DOCUMENTOS_EDOCS, compraId)
                await this.$store.dispatch(actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA, compraId)
            } catch (e) {
                this.mostrarNotificacaoErro(e.message)
            }
        },
        async incluirPropostaManual() {
            const compraId = this.idCompraAtivo
            if (!compraId) return
            try {
                this.$router.push({ name: 'CompradorIncluirPropostaManualTermo', params: { id: compraId } })
            } catch (e) {
                const msg = (e && e.response && e.response.data && (e.response.data.message || e.response.data.mensagem)) || e.message || 'Não foi possível abrir a inclusão de proposta manual.'
                this.mostrarNotificacaoErro(msg)
            }
        }
    },
    watch: {
        idCompraAtivo: {
            handler(newVal) {
                if (newVal) {
                    this.buscarSituacaoEdocs()
                }
            },
            immediate: true
        },

        paineis() {
            let todosExpandidos = true
            let todosRecolhidos = true
            for (let posicao of this.paineis) {
                if (!posicao) {
                    todosExpandidos = false
                } else {
                    todosRecolhidos = false
                }
            }
            this.totalmenteExpandido = todosExpandidos
            this.totalmenteRecolhido = todosRecolhidos
            this.verificarUltimoEstado()
        },
        paginacao: {
            handler(newVal) {
                this.paginacaoInterna = { ...newVal }
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style scoped lang="stylus">
    .botao-encerrar
        text-transform capitalize

    .botao-incluir-proposta-manual
        text-transform capitalize

    .alinhar-info
        display flex
        align-items center

    .titulo
        font-size 1.1rem
        color #777
        margin-left 16px
        clear both

    .botaoDesempatar
        padding 0 15px
        height 31px
        margin-left 20px

    .resultado-card
        display flex
        justify-content space-between
        align-items center

        h3
            font-size 1.1rem

    .documentos-compra-direta
        margin-right 10px

    .paginacao-footer
        padding 16px
        border-top 1px solid #e0e0e0
        margin-top 16px

        .btn-rows-per-page
            min-width 56px
            text-transform none

    @media (max-width 500px)
        .resultado-card h3
            font-size 1rem

        .botaoDesempatar
            margin-left 10px
</style>
